import { AnimatePresence } from "motion/react";
import { Outlet, useParams } from "react-router-dom";

import Container from "./containers/Container";
import MainContentContainer from "./containers/MainContentContainer";

import { ClientSidebar } from "@/components/ui/v2/navigation/ClientSidebar";
import Topbar from "@/components/ui/v2/navigation/Topbar";
import TopNavigation from "@/components/ui/v2/navigation/TopNavigation";
import { SidebarProvider } from "@/components/ui/v2/sidebar";
import { CaptainChatButton } from "@/features/captain/components/CaptainChatButton";
import { CaptainChatPanel } from "@/features/captain/components/CaptainChatPanel";
import { useAuth } from "@/lib/hooks/useAuth";
import { cn } from "@/lib/utils/cn";
import { useAdminRoutes } from "@/routes/useAdminRoutes";

const Layout = () => {
  const { items } = useAdminRoutes();
  const { context } = useAuth();
  const { clientId } = useParams();
  const show =
    context === "client" || (context === "admin" && clientId) ? true : false;
  return (
    <Container className="overflow-hidden px-0 md:px-0">
      <nav data-slot="app-nav" className="fixed w-full top-0 z-30">
        <Topbar />
        {context === "admin" && <TopNavigation items={items} />}
      </nav>
      <SidebarProvider>
        <section className="flex gap-4 w-full h-screen">
          <AnimatePresence mode="popLayout">
            {show && <ClientSidebar key={"sidebar"} />}
          </AnimatePresence>
          <MainContentContainer className="overflow-y-auto [scrollbar-gutter:stable] has-[[data-sticky-footer]]:scroll-pb-24">
            <Container
              className={cn(
                "py-8 pb-24 md:px-4 xl:px-8",
                context === "admin" ? "mt-28" : "mt-16",
              )}
            >
              <Outlet />
            </Container>
          </MainContentContainer>
        </section>
      </SidebarProvider>
      <CaptainChatPanel />
      <CaptainChatButton />
    </Container>
  );
};

export default Layout;
